<app-nav-pages></app-nav-pages>

<main >
  <section class="hero-section d-flex justify-content-center align-items-center csr-hero">
    <div class="overlay"></div>
    <div class="hero-text d-flex align-items-center text-center  flex-column gap-5 ">
      <h2>News and Media</h2>
    </div>
  </section>

  <section class=" container my-5">
    <h2>News</h2>

    <div class="our_news d-flex flex-wrap justify-content-between gap-3   ">

      @for (blog of blogs; track blog) {
        <article class="">
          <div class=" news-card">
            <div class="card-thumbnail d-flex flex-column  align-items-center ">
              <div class="card_image w-100">
                <img src="{{blog?.cloudinaryUrls[0]}}" class="img-fluid " alt="">
              </div>
              <div class="thumbnail-text w-100 p-3">
                <h3 class="">
                  <a routerLink="/news/{{blog?._id}}">
                    {{blog?.title}}
                  </a>
                </h3>
                <a routerLink="/news/{{blog?._id}}">Read More <span class="read-arrow">&#8594;</span></a>
              </div>
            </div>
          </div>
        </article>
      }


    </div>
  </section>

</main>

<div class="my-5  d-flex flex-column ">
  <p class="quote_3_p text-center">NEXT <span class="rdj_bold">&#8594;</span></p>
  <h3 class="mb-3 text-center rdj_bold"> CONTACT</h3>
  <a routerLink="/contact-us" class="know-more-btn align-self-center ">KNOW MORE</a>
</div>
<app-footer class="w-100 d-none d-sm-block"></app-footer>
<app-footer-sm  class="w-100 d-sm-none"></app-footer-sm>

@if (showModal === true) {
  <div class="modal-backdrop" (click)="closeModal()"></div>
}
@if (showModal === true) {
  <div class="modal-test">
    <div class="modal-content">
      <span class="close" (click)="closeModal()">&times;</span>
      <h2>Subscribe to Our Newsletter</h2>
      <form #subscribeForm="ngForm">
        <div class="mb-3">
          <label for="exampleInputPassword1"  class="form-label">Full Name</label>
          <input ngModel name="name" type="text" class="form-control" id="exampleInputPassword1">
        </div>
        <div class="mb-3">
          <label for="exampleInputEmail1" class="form-label">Email address</label>
          <input ngModel type="email" name="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp">
          <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div>
        </div>
        <button type="submit" class="btn z-full-red  text-center "  (click)="onSubscription(subscribeForm.value)">Subscribe</button>
      </form>
    </div>
  </div>
}
